<template>
  <div>

    <div v-html="$let('AccountDetailsSectionTitle')" class="subtitle-enquiry my-5"></div>

    <v-row>
      <v-col cols="12" md="6">
        <TextField 
          type="number"
          maxlength="8"
          max="99999999"
          v-model="model.accountNumber" 
          v-if="elsInUse[propertyModelName + 'AccountNumber']"
          @change="_changeModel"
          :label="elsLabel[propertyModelName + 'AccountNumber']"
          :helperText="elsHelperText[propertyModelName + 'AccountNumber']"
          :rules="[rules.numeric, rules.fixedLength(model.accountNumber, 8), elsRequired[propertyModelName + 'AccountNumber'] ? rules.required : true]">
        </TextField>
      </v-col>

      <v-col cols="12" md="6">
        <TextField 
          maxlength="8"
          v-model="model.sortCode" 
          v-if="elsInUse[propertyModelName + 'SortCode']"
          @change="_changeModel"
          @keypress="_keypressSortCode"
          @keyup="_keyupSortCode"
          @paste="_paste"
          :label="elsLabel[propertyModelName + 'SortCode']"
          :helperText="elsHelperText[propertyModelName + 'SortCode']"
          :rules="[rules.sortCode, rules.fixedLength(model.sortCode, 8), elsRequired[propertyModelName + 'SortCode'] ? rules.required : true]">
        </TextField>

        <div :bind="formatedValue" />

      </v-col>
    </v-row>

  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import TextField from '@/shared/components/text-field.vue'
  import generic from '@/shared/utils/generic.js';
  import opmGeneric from '../utils/generic.js';

  export default {
    name: 'AccountDetails',
    components: { 
      TextField
    },
    emits: ["input"],
    props: {
      rules: { type: Object },
      propertyModelName: { type: String },
    }, 
    data() {
      return {
        typingSortCode: false,
        formatedValue: "",
        model: {
          accountNumber: undefined,
          sortCode: undefined,
        }
      };
    },
    async created() { 
        opmGeneric.setElementsConfig(this, this.elementsConfig); 
    },
    methods: {
      _changeModel() {
        this.$emit("input", generic.toArray(this.model));
      },

      _keypressSortCode($event) {
        if (this.typingSortCode) $event.preventDefault();
        this.typingSortCode = true;
        // Only allow numbers
        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if (keyCode < 48 || keyCode > 57 || this.targetLength($event)) {
          $event.preventDefault();
          this.typingSortCode = false;
        }
      },

      _keyupSortCode($event) {
        // Backspace or Tab keys
        const value = $event.target.value;
        if ((!($event.keyCode === 8 || $event.keyCode === 9)) && value.length > 2) $event.target.value = this.formatSortCode(value);
        this.typingSortCode = false;
      },

      _paste($event) {
        const pastedValue = $event.clipboardData.getData('text').replaceAll(" ", "").replaceAll("-", "");
        // -2 strip sort code separators
        if (!pastedValue.isNumeric() || pastedValue.length != ($event.target.maxLength - 2)) $event.preventDefault();
      },

      targetLength($event) {
        const value = $event.target.value + $event.key;
        if (!value) return false;
        return value.length > $event.target.maxLength;
      },

      formatSortCode(value) {
        value = value.replaceAll(" ", "").replaceAll("-", "");
        let newValue = "";
        Array.from(value).forEach((el, idx) => { newValue += (idx === 2 || idx === 4 ? "-" : "") +  el; });
        return newValue;
      }

    },
    computed: {
      ...mapGetters(["elementsConfig"]),
    }
  };
</script>

<style lang="scss" scoped>

</style>